<tg-mobile-full-screen-dialog [fixedHeader]="true">
  <h2 class="title" i18n="Day posts dialog|title @@dayPostsDialog.title">Список постов</h2>
  <div>
    @for (post of posts; track post) {
      <tg-post-item [post]="post" (edit)="editPost($event)" (editMsg)="editPostMsg($event)"></tg-post-item>
    }
  </div>
</tg-mobile-full-screen-dialog>
